import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
    gap: 0.5rem;

    width: 100%;
    min-height: auto;

    background: #FFFFFF;
    border-radius: 0.75rem;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 8px rgba(10, 30, 61, 0.06);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(10, 30, 61, 0.12);
      border-color: #e8e8e8;
    }

    flex: 1;

    @media (max-width: 768px) {
      padding: 0.75rem;
      gap: 0.4rem;
    }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  padding: 0;
  gap: 0.75rem;

  width: 100%;
  height: 100%;
`

export const Heading = styled.div`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    color: #717178;

    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
`

export const ItemContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: start;
    padding: 0;
    gap: 1.25rem;

    width: 100%;

    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;

    @media (max-width: 500px) {
      grid-template-columns: 1fr;
      gap: 1rem;
    }
`

export const ItemContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    gap: 0.4rem;

    width: 100%;
    height: auto;

    flex: none;
    order: 0;
    flex-grow: 1;
    cursor: default;
`

export const ItemContentName = styled.div`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 0.7rem;
    line-height: 0.875rem;

    color: #98999f;
    height: auto;
`

export const ItemContentValue = styled.div`
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.5rem;
    display: flex;
    align-items: center;

    color: #0a1e3d;

    flex: none;
    order: 0;
    flex-grow: 0;
`

export const CardIcon = styled.div<{ index: number }>`
  width: 2rem;
  height: 2rem;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1rem;
  color: white;
  flex-shrink: 0;

  ${props => {
    const colors = [
      'linear-gradient(135deg, #0a1e3d 0%, #1a3a5c 100%)',
      'linear-gradient(135deg, #ff8c42 0%, #ff7b21 100%)',
      'linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)',
    ];
    return `background: ${colors[props.index % colors.length]};`;
  }}

  @media (max-width: 768px) {
    width: 1.75rem;
    height: 1.75rem;
    font-size: 0.9rem;
  }
`
